import { dataMember, required, typedArray } from 'santee-dcts';
import * as moment from 'moment';

export class AnnouncementInfo {

    @dataMember()
    @required()
    public id: number;

    @dataMember()
    @required()
    public text: string;

    @dataMember()
    @required()
    public title: string;

    @dataMember({ customDeserializer: value => moment(value) })
    @required()
    public effectiveStartDate: moment.Moment;

    @dataMember({
        customDeserializer: value => {
            const date = moment(value);
            return date.isValid() ? date : null;
        }
    })
    @required({ nullable: true })
    public effectiveEndDate?: moment.Moment;

    @dataMember({ customDeserializer: value => moment(value) })
    @required()
    public posted: moment.Moment;

    @dataMember()
    @required()
    @typedArray(String)
    public roles: string[];

    @dataMember()
    @required()
    public pinnedFlag: boolean;
}

export class AnnouncementsInfoReadModel {
    @dataMember()
    @required()
    @typedArray(AnnouncementInfo)
    public announcements: AnnouncementInfo[];
}